module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-9-0580802d9be5538b76aef8991deef19c.jpg";